import { render, staticRenderFns } from "./HistoricoTitulo.vue?vue&type=template&id=9a39c3b2"
import script from "./HistoricoTitulo.vue?vue&type=script&lang=js"
export * from "./HistoricoTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports